import { render, staticRenderFns } from "./QaImprove.vue?vue&type=template&id=50c6414f&scoped=true"
import script from "./QaImprove.vue?vue&type=script&lang=js"
export * from "./QaImprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c6414f",
  null
  
)

export default component.exports